<div #dialog>
  <!-- Modal Header <ng-container *ngIf="(loaded$ | async) || modalIsOpen; else loading">  -->
  @if ((loaded$ | async) || modalIsOpen) {
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        {{
        (increment || (addedEntryWasMerged$ | async)
        ? 'addToCart.itemsIncrementedInYourCart'
        : 'addToCart.itemsAddedToYourCart'
        ) | cxTranslate
        }}
      </div>
      <!-- cxModal="dismiss"
      cxModalReason="Cross click" -->
      <button type="button" class="close" aria-label="Close" (click)="dismissModal('close')">
        <span aria-hidden="true">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>
    <!-- Modal Body -->
    @if (entry$ | async; as entry) {
      <div class="cx-dialog-body modal-body">
        <div class="cx-dialog-row">
          <div class="cx-dialog-item col-sm-12 col-md-7">
            <app-custom-cart-item
              [item]="entry"
              [compact]="true"
              [uomCode]="uomCode"
              [uomName]="uomName"
              [hasStock]="hasStock"
              [maxQuantity]="maxQuantity"
              [quantityControl]="getQuantityControl() | async"
              [promotionLocation]="promotionLocation"
            ></app-custom-cart-item>
          </div>
          <!-- Separator -->
          <div class="cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none"></div>
          <!-- Total container -->
          <div class="cx-dialog-actions col-sm-12 col-md-5">
            @if (cart$ | async; as cart) {
              <div class="text-right mb-2">
                @if (showExportError) {
                  <div class="alert alert-danger export-error ng-star-inserted my-3">
                    <span class="alert-icon"><cx-icon class="cx-icon fas fa-exclamation-circle"></cx-icon></span>
                    <span>{{ exportErrorMsg }}</span>
                  </div>
                }
                <app-custom-button
                  [title]="'importCart.exportCart' | cxTranslate"
                  [showSpinner]="showSpinner"
                  styleClass="btn-small"
                  (clicked)="exportCart(cart.code)"
                  >
                </app-custom-button>
              </div>
              <div class="cx-dialog-total">
                <div>
                  {{ 'cartItems.cartTotal' | cxTranslate: { count: cart.deliveryItemsQuantity } }}
                  <span>({{ cart.deliveryItemsQuantity }} items)</span>
                </div>
                <div>{{ cart.subTotal?.formattedValue }}</div>
              </div>
            }
            <!-- Promotions -->
            @if (orderPromotions$ | async; as orderPromotions) {
              <div class="cx-dialog-promotions">
                <!-- <cx-promotions [promotions]="orderPromotions"></cx-promotions> -->
              </div>
            }
            <!-- Actions -->
            <div class="cx-dialog-buttons">
              <!-- cxModalReason="View Cart click" -->
              <button
                [class.disabled]="form.dirty"
                [routerLink]="{ cxRoute: 'cart' } | cxUrl"
                (click)="dismissModal('close')"
                class="btn btn-primary"
                autofocus
                >
                {{ 'addToCart.viewCart' | cxTranslate }}
              </button>
              <button (click)="redirectToProductsPage()" class="btn btn-secondary" data-testid="continue-shopping">
                {{ 'addToCart.continueShopping' | cxTranslate }}
              </button>
              <!-- cxModal="dismiss" -->
              <!-- TODO AC-1329 -->
              <!--<a-->
              <!--  [class.disabled]="form.dirty"-->
              <!--  [routerLink]="{ cxRoute: 'checkout' } | cxUrl"-->
              <!--  cxModal="dismiss"-->
              <!--  cxModalReason="Proceed To Checkout click"-->
              <!--  class="btn btn-secondary"-->
              <!--  (click)="dismissModal()"-->
            <!--  >{{ 'addToCart.proceedToCheckout' | cxTranslate }}</a-->
            <!--&gt;-->
          </div>
        </div>
      </div>
    </div>
  }
} @else {
  <div class="cx-dialog-header modal-header">
    <div class="cx-dialog-title modal-title">
      {{ 'addToCart.updatingCart' | cxTranslate }}
    </div>
    <button type="button" class="close" aria-label="Close" cxModal="dismiss" cxModalReason="Cross click">
      <span aria-hidden="true">
        <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
      </span>
    </button>
  </div>
  <!-- Modal Body -->
  <div class="cx-dialog-body modal-body">
    <div class="cx-dialog-row">
      <div class="col-sm-12"><cx-spinner></cx-spinner></div>
    </div>
  </div>
}

</div>
